export default __webpack_public_path__ + "img/square_1.9d779be507b42706feea2abc41d18d22.jpg";